import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

import Style from "./style";
import MyStoreTicket from "./ui/MyStoreTicketRecord";
import GiveModal from "./ui/GiveModal";

import MainHeader from "widget/MainHeader";

import useGetMyStore from "entity/store/useGetMyStore";

import DTStyle from "shared/style/detailTableStyle";
import timestampCalculator from "shared/lib/timestampCalculator";
import DefaultModal from "shared/ui/DefaultModal";
import DefaultButton from "shared/ui/DefaultButton";
import useLoginCookie from "shared/model/useLoginCookie";
import useConfrimCookie from "shared/model/useConfrimCookie";
import useRoleCookie from "shared/model/useRoleCookie";
import { ROLE_FRANCHISE_MANAGER } from "shared/constant/lookup/role";

//
const MyStore = () => {
  const navigate = useNavigate();

  const [confirmCookie, , deleteConfirmCookie] = useConfrimCookie();
  const [cookie, , deleteCookie] = useLoginCookie();
  const [isReturnModalOpen, setIsReturnModalOpen] = useState(false);
  const numberRef = useRef();
  const [roleCookie] = useRoleCookie();

  // 매니저 이용권 지급
  const removeTicket = async () => {
    if (!numberRef.current) return;

    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/admin/store_ticket/return`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: cookie,
          confirm: confirmCookie,
        },
        body: JSON.stringify({
          type: "RETURN",
          count: Number(numberRef.current.value),
          storeManagerId: myStoreData?.data?.idx,
        }),
      }
    );

    switch (response.status) {
      case 200:
        window.location.reload();
        break;
      case 400:
        alert("존재하는 이용권이 없습니다.");
        break;
      default:
        alert("서버에러가 발생 했습니다.");
    }
  };

  const [isGiveModalOpen, setIsGiveModalOpen] = useState(false);

  const [myStoreData] = useGetMyStore();

  const btnList = [
    ...(roleCookie === ROLE_FRANCHISE_MANAGER
      ? []
      : [
          {
            label: "매장 정보 수정",
            clickEvent: () => navigate("/store/my/edit"),
          },
        ]),
    {
      label: "매장 이용권 지급 & 회수",
      clickEvent: () => setIsGiveModalOpen(true),
    },
    {
      label: "매장 이용권 반환",
      clickEvent: () => setIsReturnModalOpen(true),
    },
  ];
  const myDataList = [
    {
      label: "IDX",
      value: myStoreData?.data?.idx,
    },
    {
      label: "상태",
      value: myStoreData?.data?.is_approve ? "승인" : "미승인",
    },
    {
      label: "이름",
      value: myStoreData?.data?.name,
    },
    {
      label: "연락처",
      value: myStoreData?.data?.contact,
    },
    {
      label: "가입 날짜",
      value: timestampCalculator(myStoreData?.data?.created_at),
    },
    {
      label: "이용권 보유 수량",
      value: myStoreData?.data?.ticketCount,
    },
  ];
  const myStoreDataList = [
    {
      label: "매장 이름",
      value: myStoreData?.data?.store_name,
    },
    {
      label: "매장 주소",
      value: myStoreData?.data?.store_address,
    },
  ];

  return (
    <>
      {isGiveModalOpen && (
        <GiveModal closeEvent={() => setIsGiveModalOpen(false)} />
      )}

      {isReturnModalOpen && (
        <DefaultModal
          title={"매장 이용권 반환"}
          closeEvent={() => setIsReturnModalOpen(false)}
        >
          <Style.GiveDiv>
            <input placeholder="개수 입력" ref={numberRef} />
            <DefaultButton
              small
              fitWidth
              expandHeight
              clickEvent={removeTicket}
            >
              반환
            </DefaultButton>
          </Style.GiveDiv>
        </DefaultModal>
      )}

      <Style.Wrapper>
        <MainHeader btnList={btnList}>매장</MainHeader>

        <Style.AreaDiv>
          <h2>내 정보</h2>
          <DTStyle.TableDiv>
            {myDataList?.map((elem) => (
              <DTStyle.TableElement>
                <h2>{elem?.label}</h2>
                <p>{elem?.value}</p>
              </DTStyle.TableElement>
            ))}
          </DTStyle.TableDiv>
        </Style.AreaDiv>

        {roleCookie === ROLE_FRANCHISE_MANAGER ? (
          <></>
        ) : (
          <Style.AreaDiv>
            <h2>내 매장 정보</h2>
            <DTStyle.TableDiv>
              {myStoreDataList?.map((elem) => (
                <DTStyle.TableElement>
                  <h2>{elem?.label}</h2>
                  <p>{elem?.value}</p>
                </DTStyle.TableElement>
              ))}
            </DTStyle.TableDiv>
          </Style.AreaDiv>
        )}

        <MyStoreTicket />
      </Style.Wrapper>
    </>
  );
};

export default MyStore;
